<template>
  <div class="">
		<intelligentAgriculturalMachineryNewMap
			ref="intelligentAgriculturalMachineryMap"
		></intelligentAgriculturalMachineryNewMap>
    <div class="bottom-tl flex justb">
      <div class="flex alit">
        <img
          src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%86%9C%E4%BA%8B/%E5%9B%BE%E4%BE%8B%E5%B7%B2%E5%AE%8C%E6%88%90%402x.png"
          alt=""
        />
        已完成
      </div>
      <div class="flex alit">
        <img
          src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%86%9C%E4%BA%8B/%E5%9B%BE%E4%BE%8B%E8%BF%9B%E8%A1%8C%E4%B8%AD%402x.png"
          alt=""
        />
        进行中
      </div>
      <div class="flex alit">
        <img
          src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%86%9C%E4%BA%8B/%E5%9B%BE%E4%BE%8B%E6%9C%AA%E5%BC%80%E5%A7%8B%402x.png"
          alt=""
        />
        未开始
      </div>
      <div class="flex alit">
        <img
          src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%86%9C%E4%BA%8B/%E5%9B%BE%E4%BE%8B%E5%B7%B2%E8%B6%85%E6%9C%9F%402x.png"
          alt=""
        />
        已超期
      </div>
    </div>
    <div class="mengban"></div>
    <!-- <div class="top-data flex justb">
      <div class="flexCol alit">
        <div class="text1">
          {{ crop.cropArea
          }}<a
            style="
              color: #ffffff;
              font-size: 14px;
              font-family: PingFangSC, PingFang SC;
            "
            >(亩)</a
          >
        </div>
        <img
          src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%86%9C%E4%BA%8B/%E7%A7%8D%E6%A4%8D%E9%9D%A2%E7%A7%AF%402x.png"
          alt=""
        />
        <div class="text2">种植面积</div>
      </div>
      <div class="flexCol alit">
        <div class="text1">
          {{ crop.plotNum
          }}<a
            style="
              color: #ffffff;
              font-size: 14px;
              font-family: PingFangSC, PingFang SC;
            "
            >(块)</a
          >
        </div>
        <img
          src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%86%9C%E4%BA%8B/%E5%9C%B0%E5%9D%97%E6%95%B0%E9%87%8F%402x.png"
          alt=""
        />
        <div class="text2">地块数量</div>
      </div>
      <div class="flexCol alit">
        <div class="text1">
          {{ crop.cropYield
          }}<a
            style="
              color: #ffffff;
              font-size: 14px;
              font-family: PingFangSC, PingFang SC;
            "
            >(万吨)</a
          >
        </div>
        <img
          src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%86%9C%E4%BA%8B/%E9%A2%84%E8%AE%A1%E4%BA%A7%E9%87%8F%402x.png"
          alt=""
        />
        <div class="text2">预计产量</div>
      </div>
    </div> -->
    <!-- <div class="back" @click="$router.go(-1)">返回</div> -->
    <div class="left noselect">
      <div class="title">农机概览</div>
      <div class="flex alit">
        <div class="flexCol" style="flex: 1">
          <div class="flex justb" style="margin: 0 0 30px 40px; flex: 1">
            <div class="flexCol alit">
              <div class="ns-tt" style="color: #23ea99">拖拉机</div>
              <div class="ns-num">0 <a style="font-size: 14px">台</a></div>
            </div>
            <div class="flexCol alit">
              <div class="ns-tt" style="color: #ffd725">收割机</div>
              <div class="ns-num">0 <a style="font-size: 14px">台</a></div>
            </div>
            <div class="flexCol alit">
              <div class="ns-tt" style="color: #ffd725">无人机</div>
              <div class="ns-num">0 <a style="font-size: 14px">台</a></div>
            </div>
          </div>
          <div class="flex justb" style="margin: 0 0 30px 40px; flex: 1">
            <div class="flexCol alit">
              <div class="ns-tt" style="color: #eb5e00">播种机</div>
              <div class="ns-num">0 <a style="font-size: 14px">台</a></div>
            </div>
            <div class="flexCol alit">
              <div class="ns-tt" style="color: #0083ff">喷药机</div>
              <div class="ns-num">0 <a style="font-size: 14px">台</a></div>
            </div>
            <div class="flexCol alit">
              <div class="ns-tt" style="color: #0083ff">去雄机</div>
              <div class="ns-num">0 <a style="font-size: 14px">台</a></div>
            </div>
          </div>
        </div>
      </div>
      <div class="title">农机效率</div>
      <leftCenter></leftCenter>
      <div class="title">农机任务</div>
      <div class="aifx-title flex justb alit">
        <!-- <div class="" style="width: 10%">
          <el-checkbox style="margin-left: -10px"></el-checkbox>
        </div> -->
        <div class="" style="width: 25%">任务名称</div>
        <div class="" style="width: 20%">任务类型</div>
        <div class="" style="width: 15%">状态</div>
        <div class="" style="width: 20%">日期</div>
        <div class="" style="width: 20%">负责人</div>
      </div>
      <vue-seamless-scroll
        :data="taskList"
        class="warp"
        :class-option="classOption3"
        style="overflow: hidden; margin-top: 10px"
      >
        <ul class="item" style="list-style-type: none; padding: 0">
          <li
            v-for="(item, index) in taskList"
            :key="index"
            class="flex alit"
            style="height: 36px; margin-bottom: 10px"
            :data="JSON.stringify(item)"
          >
            <div class="ai-list flex alit" style="flex: 1">
              <!-- <div class="flexCol alit" style="width: 10%">
                <el-checkbox></el-checkbox>
              </div> -->
              <div class="" style="width: 25%">
                {{ item.taskName }}
              </div>
              <div class="" style="width: 20%">
                {{ item.taskType }}
              </div>
              <div
                class=""
                style="width: 15%"
                :style="{ color: statusColor[item.status - 1] }"
              >
                {{ changeStatus(item.status) }}
              </div>
              <div class="textOne" style="width: 20%">
                <el-tooltip
                  effect="dark"
                  :content="utils.changeTimeNoHms(item.createDate)"
                  placement="top"
                >
                  <div class="">
                    {{ utils.changeTimeNoHms(item.createDate) }}
                  </div>
                </el-tooltip>
              </div>
              <div class="" style="width: 20%">
                {{ item.person }}
              </div>
            </div>
          </li>
        </ul>
      </vue-seamless-scroll>

      <div class="time-cont">
        <div class="time-style" @click="changeNsTime(1)">今日</div>
        <div class="time-style" @click="changeNsTime(2)">昨日</div>
        <div class="time-style" @click="changeNsTime(3)">近一周</div>

        <el-popover placement="right" width="400" trigger="click">
          <el-date-picker
            v-model="nsDate"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="changeNsDate"
          >
          </el-date-picker>
          <div slot="reference" class="time-style">自定义</div>
        </el-popover>
      </div>
    </div>
    <div class="right noselect">
      <div class="title">设备监测</div>
      <rightTop style="width: 100%;"></rightTop>
      <div class="title">调度计划</div>
      <div class="ns-plan">
        <div v-for="item in nsPlan" :key="item.title">
          <div class="set-early1 flex">
            <div
              style="
                margin-top: 5px;
                margin-left: 20px;
                color: #fab040;
                font-size: 16px;
                font-family: YouSheBiaoTiHei;
              "
            >
              {{ item.title }}
            </div>
          </div>
          <div class="" style="display: grid; grid-template-columns: 1fr 1fr;height: 130px;">
            <div class="plan-left flex alit justc">
              <img
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%86%9C%E4%BA%8B/xia%402x.png"
                style=""
                alt=""
              />
              <div class="pshuxian"></div>
            </div>
            <div class="planc">
              <div class="flex plan-cont" v-for="ite in item.content">
                <img :src="ite.icon" class="plan-icon" alt="" />
                {{ ite.cont }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import intelligentAgriculturalMachineryNewMap from "./intelligentAgriculturalMachineryNewMap.vue";
import vueSeamlessScroll from "vue-seamless-scroll";
import leftCenter from "./leftCenter.vue";
import rightTop from "./rightTop.vue";
export default {
  components: {
    intelligentAgriculturalMachineryNewMap,
    vueSeamlessScroll,
    leftCenter,
    rightTop,
  },
  data() {
    return {
      statusColor: ["#00DDA2", "#0083FF", "#FFD725", "#EB5E00"],
      nsPlan: [
        {
          title: "拖拉机",
          content: [
            // {
            //   icon: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%86%9C%E4%BA%8B/%E7%BC%96%E7%BB%84%2027%402x.png",
            //   cont: "启用电动微耕机替代部分拖拉机短途运输任务，降低燃油机损耗。",
            // },
            // {
            //   icon: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%86%9C%E4%BA%8B/%E7%BC%96%E7%BB%84%2025%402x.png",
            //   cont: "将全部燃油拖拉机转移至遮阳棚下待机，仅保留1台备用机组用于应急移动。",
            // },
          ],
        },
        // {
        //   title: "无人机",
        //   content: [
        //     {
        //       icon: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%86%9C%E4%BA%8B/%E7%BC%96%E7%BB%84%2027%402x.png",
        //       cont: "常规模式效率高但耗电快，低功耗模式续航长但覆盖范围缩小。",
        //     },
        //     {
        //       icon: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%86%9C%E4%BA%8B/%E7%BC%96%E7%BB%84%2023%402x.png",
        //       cont: "启动“接力作业”机制，调用邻近地块备用无人机协同完成任务。",
        //     },
        //   ],
        // },
        {
          title: "喷药机",
          content: [
            // {
            //   icon: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%86%9C%E4%BA%8B/%E7%BC%96%E7%BB%84%2027%402x.png",
            //   cont: "加装GPS定位模块，实时监控喷洒轨迹，避免重复/遗漏。",
            // },
            // {
            //   icon: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%86%9C%E4%BA%8B/%E7%BC%96%E7%BB%84%2025%402x.png",
            //   cont: "同步开启“智能启停”功能，根据机车速度自动调节阀门开关，减少药液浪费。",
            // },
          ],
        },
        {
          title: "去雄机",
          content: [
            // {
            //   icon: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%86%9C%E4%BA%8B/%E7%BC%96%E7%BB%84%2027%402x.png",
            //   cont: "单台去雄机日作业量约80亩，需匹配地块大小。",
            // },
            // {
            //   icon: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%86%9C%E4%BA%8B/%E7%BC%96%E7%BB%84%2025%402x.png",
            //   cont: "去雄期间每2小时复查植株高度，若提前达标则手动触发调度程序。",
            // },
          ],
        },
      ],
      classOption3: {
        singleHeight: 46,
        limitMoveNum: 11,
        hoverStop: true,
        waitTime: 4000,
      },
      taskList: [],
      taskCount: {},
      crop: {},
      startTime: "",
      endTime: "",
      nsDate: [],
    };
  },
  mounted() {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getLeftTopData();
    this.getLeftBottomData();
    // this.getCenterData();
  },
  methods: {
    changeNsDate(e) {
      if (e) {
        this.startTime = this.utils.changeTimeNoHms(e[0]);
        this.endTime = this.utils.changeTimeNoHms(e[1]);
      } else {
        this.startTime = "";
        this.endTime = "";
      }
      this.getLeftBottomData();
    },
    changeNsTime(e) {
      const today = new Date();
      switch (e) {
        case 1:
          //今日
          this.startTime = this.utils.changeTimeNoHms(new Date());
          this.endTime = this.utils.changeTimeNoHms(new Date());
          this.getLeftBottomData();
          break;
        case 2:
          //昨日
          // 获取昨日日期
          const yesterday = new Date(today);
          yesterday.setDate(yesterday.getDate() - 1);
          this.startTime = this.utils.changeTimeNoHms(yesterday);
          this.endTime = this.utils.changeTimeNoHms(yesterday);
          this.getLeftBottomData();
          break;
        case 3:
          //近一周
          // 获取昨日日期
          const weekDay = new Date(today);
          weekDay.setDate(weekDay.getDate() - 7);
          this.startTime = this.utils.changeTimeNoHms(weekDay);
          this.endTime = this.utils.changeTimeNoHms(today);
          this.getLeftBottomData();
          break;
        default:
          break;
      }
    },
    // getCenterData() {
    //   this.$request(`iot/screen/plot/getCrop?id=${this.$route.query.id}`).then(
    //     (res) => {
    //       this.crop = res.data;
    //     }
    //   );
    // },
    getLeftTopData() {
      this.$request("iot/screen/plot/getTaskCount").then((res) => {
        this.taskCount = res.data;
      });
    },
    getLeftBottomData() {
      this.$request(
        `iot/screen/plot/listTask?startDate=${this.startTime}&endDate=${this.endTime}&type=2`
      ).then((res) => {
        // this.taskList = res.data;
        setTimeout(() => {
          this.$refs.intelligentAgriculturalMachineryMap.setMarkers(res);
        }, 1000);
      });
    },
    changeStatus(e) {
      switch (e) {
        case 1:
          return "已完成";
          break;
        case 2:
          return "进行中";
          break;
        case 3:
          return "未开始";
          break;
        case 4:
          return "已超期";
          break;
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.back {
  width: 29px;
  height: 74px;
  background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/%E8%BF%94%E5%9B%9E%402x.png");
  background-size: 100% 100%;

  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;

  writing-mode: vertical-lr;
  /* 垂直排列，从右到左 */
  letter-spacing: 4px;
  text-align: center;
  line-height: 28px;
  letter-spacing: 5px;
  cursor: pointer;

  position: fixed;
  top: 100px;
  right: 500px;
  z-index: 99;
}
.bottom-tl {
  position: fixed;
  bottom: 30px;
  width: 20%;
  margin-left: 40%;
  z-index: 99;
  img {
    width: 15px;
    height: auto;
    margin-right: 5px;
    margin-left: 10px;
  }

  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
}
.top-data {
  width: 36%;
  position: fixed;
  top: 130px;
  left: 32%;
  z-index: 99;
  .text1 {
    font-family: YouSheBiaoTiHei;
    font-size: 30px;
    color: #fab040;
    line-height: 15px;
  }
  .text2 {
    font-size: 16px;
    color: #ffffff;
    line-height: 17px;
  }
  img {
    width: 80px;
    height: 74px;
    margin-bottom: 10px;
  }
}
/* 设置滚动条整体样式 */
.ns-plan::-webkit-scrollbar {
  width: 8px;
  /* 垂直滚动条宽度 */
  height: 8px;
  /* 水平滚动条高度 */
}

/* 设置滚动条轨道 */
.ns-plan::-webkit-scrollbar-track {
  background: rgba(202, 199, 199, 0.1);
  /* 轨道背景色 */
  border-radius: 4px;
  /* 圆角 */
}

/* 设置滚动条滑块 */
.ns-plan::-webkit-scrollbar-thumb {
  background: #5d70db;
  /* 滑块颜色 */
  border-radius: 4px;
  /* 圆角 */
}

/* 设置鼠标悬停在滑块上的样式 */
.ns-plan::-webkit-scrollbar-thumb:hover {
  background: #5166db;
  cursor: pointer;
  /* 悬停时颜色 */
}
.ns-plan {
  height: 57vh;
  overflow: auto;
  margin-top: 10px;
  .plan-left {
    height: 100%;
    position: relative;
    width: 12px;
    margin-left: 12px;
    img {
      width: 12px;
      height: 13px;
      z-index: 2;
    }
    .pshuxian {
      position: absolute;
      left: 5px;
      top: 0;
      width: 2px;
      height: 100%;
      background: linear-gradient(
        180deg,
        rgba(0, 36, 83, 0),
        rgba(0, 107, 255, 0.9)
      );
    }
  }
  .plan-icon {
    width: 24px;
    height: 24px;
    margin: 10px;
  }
  .planc {
    width: 400px;
    background: linear-gradient(
      180deg,
      rgba(200, 222, 255, 0) 0%,
      rgba(78, 158, 255, 0.28) 100%
    );
    margin-bottom: 7px;
  }
  .plan-cont {
    width: 400px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    margin-top: 20px;
    border-radius: 10px;
  }
  .set-early1 {
    width: 103px;
    height: 28px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/button%402x.png");
    background-size: 100% 100%;
    .set-early2 {
      width: 20px;
      height: 17px;
      background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E7%BC%96%E7%BB%84%402x.png");
      background-size: 100% 100%;

      margin-top: 10px;
      margin-left: 13px;
    }
  }
}

.mengban {
  position: fixed;
  z-index: 97;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E9%A6%96%E9%A1%B5%E8%83%8C%E6%99%AF%402x.png");
  background-size: 100% 100%;
}
.left {
  position: fixed;
  left: 20px;
  top: 10vh;
  width: 440px;
  height: 85vh;
  // background: rgba($color: #c8eebc, $alpha: 0.6);
  z-index: 98;
  .time-cont {
    position: fixed;
    left: 470px;
    bottom: 20px;
    .time-style {
      width: 37px;
      height: 66px;
      background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%86%9C%E4%BA%8B/%E5%86%9C%E4%BA%8B%E6%97%B6%E9%97%B4%E8%83%8C%E6%99%AF%402x.png");
      background-size: 100% 100%;

      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      line-height: 14px;

      writing-mode: vertical-lr;
      /* 垂直排列，从右到左 */
      letter-spacing: 4px;
      text-align: center;
      line-height: 34px;
      letter-spacing: 5px;
      margin-top: 12px;
      cursor: pointer;
    }
  }

  .aifx-title {
    width: 440px;
    height: 36px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/ai%E6%A0%87%E9%A2%98%E6%A0%8F%402x.png");
    background-size: 100% 100%;

    font-weight: 500;
    font-size: 14px;
    color: #00ffd1;
    text-align: center;
  }
  .ai-list {
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
  }
  .warp {
    height: 550px;
    width: 100%;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.01);
    display: block;

    .yujing {
      width: 410px;
      height: 30px;
      background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E9%A2%84%E8%AD%A6%E8%83%8C%E6%99%AF%402x.png");
      background-size: 100% 100%;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      line-height: 30px;

      // background: red;
      .yujing-type {
        width: 63px;
        height: 22px;
        background: linear-gradient(
          270deg,
          rgba(43, 85, 145, 0.5) 0%,
          rgba(30, 83, 133, 0.5) 100%
        );
        border-radius: 28px;
        border: 1px solid #0083ff;
        font-weight: 400;
        font-size: 12px;
        color: #ffffff;
        margin: 0 10px;

        img {
          width: 12px;
          height: 12px;
          margin-right: 4px;
        }
      }
    }

    .item {
      padding: 0;
    }

    ul {
      list-style: none;
      padding: 10px 0;
      margin: 0;
      width: 100%;
      // background-color: rgba(255, 255, 255, 0.1);

      li {
        height: 50px;
      }

      li:hover {
        background-color: #01a8ff;
      }
    }
  }
  .ns-num {
    font-family: YouSheBiaoTiHei;
    font-size: 30px;
    color: #ffffff;
  }
  .ns-tt {
    font-family: YouSheBiaoTiHei;
    font-size: 20px;
  }
  .task-odds {
    width: 141px;
    height: 169px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%86%9C%E4%BA%8B/%E5%86%9C%E4%BA%8B%E4%BB%BB%E5%8A%A1%E5%AE%8C%E6%88%90%E7%8E%87%402x.png");
    background-size: 100% 100%;
    margin: 15px 0 33px 30px;
    .odds {
      font-weight: bold;
      font-size: 24px;
      color: #ffffff;
      line-height: 128px;
      text-shadow: 0px 0px 11px rgba(31, 105, 227, 0.86);
      margin-top: -25px;
    }
    .task-title {
      font-family: YouSheBiaoTiHei;
      font-size: 17px;
      color: #ffffff;
    }
  }
}
.right {
  position: fixed;
  right: 20px;
  top: 10vh;
  width: 440px;
  height: 85vh;
  // background: rgba($color: #c8eebc, $alpha: 0.6);
  z-index: 98;
}
</style>
